// Mirror of server/services/performance/domainOwnership.js — sibling domains
// operated by the same organisation as the analyzed site count as FIRST-party.
export const OWNERSHIP_GROUPS = [
  // VLM / Vltava Labe Media publishing group
  ['vlmedia.cz', 'vlp.cz', 'denik.cz', 'dumazahrada.cz', 'dotyk.cz', 'kondice.cz', 'recepty.cz']
];

const normalizeHost = (host) => String(host || '').toLowerCase().replace(/^www\./, '');

const baseDomainOf = (host) => {
  const h = normalizeHost(host);
  const parts = h.split('.');
  if (parts.length <= 2) return h;
  return parts.slice(-2).join('.');
};

const groupOf = (host) => {
  const base = baseDomainOf(host);
  return OWNERSHIP_GROUPS.find(g => g.includes(base)) || null;
};

// True when hostB belongs to the same site OR the same ownership group as hostA.
export const sameOwner = (hostA, hostB) => {
  const a = normalizeHost(hostA);
  const b = normalizeHost(hostB);
  if (!a || !b) return false;
  if (a === b || b.endsWith('.' + a) || a.endsWith('.' + b)) return true;
  const group = groupOf(a);
  return !!group && group.includes(baseDomainOf(b));
};
